import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import { BrowserRouter } from 'react-router-dom'
import { store } from './features/store.js'
import { Provider } from 'react-redux'
import { GoogleOAuthProvider } from '@react-oauth/google'
import { registerLicense } from '@syncfusion/ej2-base'
import { TutorialProvider } from './context/TutorialContext.js'
import { IntercomProvider } from './IntercomProvider.jsx'

import posthog from 'posthog-js'

registerLicense(process.env.REACT_APP_SYNCFUSION_API_KEY)

posthog.init(process.env.REACT_APP_POSTHOG_KEY, {
	api_host: process.env.REACT_APP_POSTHOG_HOST,
})

const root = ReactDOM.createRoot(document.getElementById('root'))

root.render(
	<GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
		<BrowserRouter>
			<Provider store={store}>
				<TutorialProvider>
					<IntercomProvider>
						<App />
					</IntercomProvider>
				</TutorialProvider>
			</Provider>
		</BrowserRouter>
	</GoogleOAuthProvider>
)
